import Image from "next/image";
import { RaisedButton } from "@/components/ui/raised-button";

export default function PublishWorkflowCTA() {
  const docsBaseUrl =
    process.env.NODE_ENV === "development"
      ? "http://localhost:3001"
      : "https://docs.heygaia.io";

  return (
    <div className="mx-auto mt-20 max-w-7xl rounded-4xl bg-black p-6 py-20 text-center relative overflow-hidden outline-zinc-900 outline-2">
      <Image
        fill
        src={"/images/wallpapers/blueprint.png"}
        alt="Blueprint image"
        className="object-cover  z-0 opacity-50 blur-[3px]"
      />
      <div className="mx-auto space-y-1">
        <h3 className="font-serif text-6xl font-normal text-foreground relative z-[1]">
          Publish Your Own Workflow
        </h3>
        <p className="text-zinc-400 relative z-[1]">
          Build and share your automation ideas with the GAIA community
        </p>
        <a
          href={`${docsBaseUrl}/guides/marketplace`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <RaisedButton color="#00bbff" className="mt-5 text-black!">
            Learn How
          </RaisedButton>
        </a>
      </div>
    </div>
  );
}
